export const iconFontAwesomeTravelHotelCarRear = (
	<i className="fa-solid fa-car-rear"></i>
);
